import { OverlayTriggerHandle } from "rsuite/esm/internals/Overlay/OverlayTrigger";
import { ColorPicker } from "@mantine/core";
import { Whisper, Popover } from "rsuite";
import { useRef, useState } from "react";
import { Button } from "reactstrap";

interface Props {
  existingValue: string;
  field: string;
  onChange: (field: string, value: string) => void;
}

const ColorCreate = ({ existingValue, field, onChange }: Props) => {
  const [colorData, setColorData] = useState({
    color: existingValue,
    valid: true,
    open: false,
    error: null,
  });
  const whisperRef = useRef<OverlayTriggerHandle | null>(null);

  return (
    <div className="cursor-pointer tw:border tw:border-gray-300 tw:rounded-sm tw:p-1 ">
      <Whisper
        ref={whisperRef}
        trigger="click"
        preventOverflow
        placement="auto"
        speaker={
          <Popover className="tw:p-0">
            <div className="tw:p-4" style={{ width: 200 }}>
              <ColorPicker
                value={colorData.color}
                format="hexa"
                fullWidth
                onChange={(color) => {
                  setColorData((prev) => ({
                    ...prev,
                    color: color,
                    error: null,
                  }));
                  onChange(field, color);
                }}
              />
              <div className="tw:relative">
                <input
                  value={colorData.color}
                  className="tw:w-full tw:border tw:rounded-sm tw:mt-2 tw:px-2 tw:py-1 tw:text-sm"
                  onChange={(e) => {
                    setColorData((prev) => ({
                      ...prev,
                      color: e.target.value,
                      error: null,
                    }));
                    onChange(field, e.target.value);
                  }}
                  type="text"
                />
                <i
                  onClick={() => {
                    setColorData((prev) => ({ ...prev, color: "" }));
                    onChange(field, "");
                  }}
                  className="mdi mdi-close cursor-pointer tw:text-sm tw:absolute tw:right-1 tw:top-[13px]"
                ></i>
              </div>
              <div className="tw:w-full tw:flex tw:justify-end tw:m-0">
                <Button
                  onClick={() => {
                    whisperRef.current?.close();
                  }}
                  size="sm"
                  className="tw:mt-2"
                  color="primary"
                >
                  Save
                </Button>
              </div>
            </div>
          </Popover>
        }
      >
        <div className="tw:flex tw:flex-row tw:items-center">
          <span
            className="tw:m-0 tw:p-0"
            style={{
              backgroundColor: colorData.color,
              display: "inline-block",
              width: "20px",
              height: "20px",
              borderRadius: "50%",
              border: "1px solid #e5e7eb",
              zIndex: 1,
            }}
          />
          <p className="tw:p-0 tw:m-0 tw:ml-2 tw:text-sm">{colorData.color}</p>
        </div>
      </Whisper>
    </div>
  );
};

export default ColorCreate;
